@if (rebrandEnabled()) {
  <pp-icon
    class="brandLogo__icon"
    role="img"
    aria-label="Pinpoint Works logo"
    [ppSVG]="iconMap[EIconPath.LOGO_HORIZONTAL_COLOUR_REBRAND]"
  ></pp-icon>
} @else {
  <img
    class="brandLogo__image"
    [src]="ppFallback()"
    alt="Pinpoint Works logo"
    title="Pinpoint Works"
  />
}
